import React, { useState, useContext, useEffect, useRef } from "react";
import "./EditPopup.css";
import "./DataList.css";
import { IoMdClose } from "react-icons/io";
import enTranslations from "./translations/en.json";
import guTranslations from "./translations/gu.json";
import hinTranslations from "./translations/hi.json";
import { LanguageContext } from "./LanguageContext";
import DatePicker from "react-datepicker";
import Multiselect from "multiselect-react-dropdown";
import { FcCalendar } from "react-icons/fc";
import axios from "axios";
import { FiUpload } from "react-icons/fi";
import mrTranslations from "./translations/mr.json";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import API_URL from "./Config";
import EntryTypeFields from "./components/common/EntryTypeFields";
import {
  buildEntryTypeValidationErrors,
  DEFAULT_ENTRY_TYPE_OPTIONS,
  normalizeEntryTypeOptions,
  normalizeEntryTypeRecord,
  sanitizeRecordForEntryType,
} from "./utils/entryTypeHelpers";
function EditPopup({ selectedData, setSelectedData, setShowEditForm }) {
  const insertRef = useRef(null);
  const handleEditClose = () => {
    setShowEditForm(false);
  };
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [sectionOfLaws, setSectionOfLaws] = useState({});
  const [userState, setUserState] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [sectionOfLaw, setSectionOfLaw] = useState("");
  const [showSpecifyActInput, setShowSpecifyActInput] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedAct, setSelectedAct] = useState("");
  const [specifyAct, setSpecifyAct] = useState("");
  const [sectionCourtOrderNo, setSectionCourtOrderNo] = useState("");
  const [sectionReleased, setSectionReleased] = useState("");
  const [sectionRelesedDate, setSectionRelesedDate] = useState("");
  const [sectionGdNo, setSectionGdNo] = useState("");
  const [sectionAuctionDate, setSectionAuctionDate] = useState("");
  const [sectionAawarded, setSectionAawarded] = useState("");
  const [sectionAuctionMemoNo, setSectionAuctionMemoNo] = useState("");
  const [sectionMemoNo, setSectionMemoNo] = useState("");
  const [isPopupOpens, setIsPopupOpen] = useState(false);
  const [sectionAuctionOrderNo, setSectionAuctionOrderNo] = useState("");
  const [sectionExecutiveOrderNo, setSectionExecutiveOrderNo] = useState("");
  const [selectedDateOfHandingOver, setSelectedDateOfHandingOver] =
    useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [sectionCfslName, setSectionCfslName] = useState('');
  const [showCasePropertyPopup, setShowCasePropertyPopup] = useState(false);
  const [showSectionOfLawInput, setShowSectionOfLawInput] = useState(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [selectedCourtOrderOption, setSelectedCourtOrderOption] = useState("Disposed");
  const [sectionDisposaldate, setSectionsectionDisposaldate] = useState("");
  const [entryTypes, setEntryTypes] = useState(DEFAULT_ENTRY_TYPE_OPTIONS);
  const [editValidationErrors, setEditValidationErrors] = useState({});

  const { selectedLanguage } = useContext(LanguageContext);
  const translations = {
    en: enTranslations,
    gu: guTranslations,
    hi: hinTranslations,
    mr: mrTranslations,
  };
  const closeUpdateButton = () => {
    setShowCasePropertyPopup(false);
  };
  const handleUploadButtonClick = () => {
    // Trigger click event of file input when upload button is clicked
    fileInputRef.current.click();
  };

  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };
  const fileInputRef = useRef(null);
  const handleSectionOfLawChange = (e, optionName) => {
    setSectionOfLaws({
      ...sectionOfLaws,
      [optionName]: e.target.value,
    });
  };


  const handleDeleteFile = (indexToDelete) => {
    setSelectedFiles(
      selectedFiles.filter((_, index) => index !== indexToDelete)
    );
  };

  const handleFileInputChange = (e, documentType) => {
    const files = e.target.files;
    const newFileDetails = Array.from(files).map((file) => ({
      name: file.name,
      size: file.size,
      type: documentType,
    }));

    setSelectedFiles([...selectedFiles, ...newFileDetails]);

    setAttachmentFile((prevFiles) => [
      ...(prevFiles || []),
      ...Array.from(files).map((file) => ({ file, type: documentType })),
    ]);
  };
  const handleIconClick = () => {
    // Show selected files when icon is clicked
    setIsPopupOpen(true);
  };

  const handleDisposalFileInputChange = (e) => handleFileInputChange(e, 'disposal');
  const handleAuctionFileInputChange = (e) => handleFileInputChange(e, 'auction');
  const handleHandedOverFileInputChange = (e) => handleFileInputChange(e, 'handedOver');
  const handleCourtOrderFileInputChange = (e) => handleFileInputChange(e, 'courtOrder');
  const [options] = useState([
    { id: 1, name: "Protection of Aboriginal Tribes Regulation 1956 (PAT)" },
    { id: 2, name: "32 Regulation III of 1876 (Excise Regulation)" },
    { id: 3, name: "Prevention of Cruelty to Animals Act, 1960" },
    { id: 4, name: "Slaughtering Act 1964" },
    { id: 5, name: "Wildlife Protection Act 1972" },
    { id: 6, name: "Indian Forest Act, 1927" },
    { id: 7, name: "Narcotic Drugs and Psychotropic Substances Act, 1985" },
    { id: 8, name: "Protection of Children from Sexual Offences Act, 2012" },
    { id: 9, name: "Indian Penal Code, 1860" },
    { id: 10, name: "Criminal Procedure Code, 1973" },
    {
      id: 11,
      name: "Juvenile Justice (Care and Protection of Children) Act, 2015",
    },
    { id: 12, name: "Arms Act 1959" },
    { id: 13, name: "Information Technology Act 2000 (IT Act)" },
    { id: 14, name: "Others Acts" },
  ]);

  const translatedText = (key) => translations[selectedLanguage][key] || key;

  useEffect(() => {
    const state = localStorage.getItem("userState");
    if (state) {
      setUserState(state);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchEntryTypes = async () => {
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/entry_types`, {
          headers: {
            Authorization: authKey,
          },
        });

        if (!isMounted) {
          return;
        }

        setEntryTypes(normalizeEntryTypeOptions(response.data));
      } catch (error) {
        console.error("Error fetching entry types:", error);
      }
    };

    fetchEntryTypes();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!selectedData) {
      return;
    }

    const normalizedData = normalizeEntryTypeRecord(selectedData, entryTypes);
    if (
      normalizedData.entry_type !== selectedData.entry_type ||
      normalizedData.receipt_number !== (selectedData.receipt_number || "") ||
      normalizedData.other_entry_type !== (selectedData.other_entry_type || "")
    ) {
      setSelectedData(normalizedData);
    }
  }, [entryTypes, selectedData, setSelectedData]);

  const clearEditValidationErrors = (...fields) => {
    setEditValidationErrors((prevErrors) => {
      const nextErrors = { ...prevErrors };
      fields.forEach((field) => {
        nextErrors[field] = false;
      });
      return nextErrors;
    });
  };

  const handleEntryTypeChange = (entryTypeCode) => {
    setSelectedData((prevData) =>
      sanitizeRecordForEntryType(
        {
          ...normalizeEntryTypeRecord(prevData, entryTypes),
          entry_type: entryTypeCode,
        },
        entryTypes
      )
    );
    clearEditValidationErrors(
      "entry_type",
      "guna_number",
      "receipt_number",
      "other_entry_type"
    );
  };

  const handleEntryTypeFieldChange = (fieldName, value) => {
    setSelectedData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
    clearEditValidationErrors(fieldName);
  };

  const handleSelect = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => option.name === "Others Acts")
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => option.name === "Others Acts")
    );
    setSelectedAct(selectedLawNames);
  };

  const updateStatusDetails = async (e) => {
    e.preventDefault();
    try {
      const authKey = localStorage.getItem("authKey");
      const newStatusOfMuddamaal = selectedData.new_status_of_muddamaal;

      const statusDetailsData = {
        ...selectedData,
        new_status_of_muddamaal: newStatusOfMuddamaal,
        court_order_no: sectionCourtOrderNo,
        released_to_whom: sectionReleased,
        release_date: sectionRelesedDate,
        gd_no: sectionGdNo,
        cfslName: sectionCfslName,
        auctionDate: sectionAuctionDate,
        executiveOrder: sectionExecutiveOrderNo,
        disposalDate: sectionDisposaldate,
        auctionOrderNo: sectionAuctionOrderNo,
        awarded: sectionAawarded,
        auctionMemoNo: sectionAuctionMemoNo,
        memoNo: sectionMemoNo,
        dateOfHandingOver: selectedDateOfHandingOver,
        paymentMode: selectedPaymentMode,
        disposalOnCourt: selectedCourtOrderOption,
      };

      // Create a FormData object
      const formData = new FormData();

      // Append the form fields to the FormData object
      Object.keys(statusDetailsData).forEach(key => {
        formData.append(key, statusDetailsData[key]);
      });

      // Append the attachments with size and type
      if (attachmentFile && attachmentFile.length > 0) {
        attachmentFile.forEach(({ file, type }) => {
          formData.append("Attachment", file);
          formData.append("FileSize", file.size);
          formData.append("DocumentType", type);
        });
      }

      // Make the PUT request to update status details
      await axios.put(
        `${API_URL}/api/custody_log_status/${selectedData.id}`,
        formData,
        {
          headers: {
            Authorization: authKey,
            'Content-Type': 'multipart/form-data', // Important for sending FormData
          },
        }
      );

      // Reset UI state after successful update
      setShowCasePropertyPopup(false);
      fetchData();

      // Show success message in Snackbar
      setSnackbarMessage("Data updated successfully!");
      setOpenSnackbar(true);

      // Hide Snackbar after 1 second
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating status details:", error);
    }
  };


  const handleRemove = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => option.name === "Others Acts")
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => option.name === "Others Acts")
    );
    setSelectedAct(selectedLawNames);
  };


  const handleDropdownCourtOrderChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCourtOrderOption(selectedValue);
  };

  
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const authKey = localStorage.getItem("authKey");
      const nextEntryTypeErrors = buildEntryTypeValidationErrors(
        selectedData,
        entryTypes
      );

      if (Object.values(nextEntryTypeErrors).some(Boolean)) {
        setEditValidationErrors(nextEntryTypeErrors);
        setSnackbarMessage("Please fill in all required fields.");
        setOpenSnackbar(true);
        return;
      }
      const sectionOfLawsObject = {};
      for (const option of selectedOptions) {
        sectionOfLawsObject[option.name] = sectionOfLaws[option.name] || "";
      }
      // Include the new_status_of_muddamaal in the selectedData
      const updatedData = {
        ...sanitizeRecordForEntryType(selectedData, entryTypes),
        act: selectedAct,
        specify_act: specifyAct,
        section_of_law: JSON.stringify(sectionOfLawsObject),
      };

      await axios.put(
        `${API_URL}/api/data/${selectedData.id}`,
        updatedData,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );
      setSelectedData(null);
      setShowEditForm(false);
      fetchData();
      setSnackbarMessage("Data updated successfully!");
      setOpenSnackbar(true);

      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating main crime data:", error);
    }
  };

  const fetchData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/data`, {
        headers: {
          Authorization: authKey,
        },
      });
      setData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const countWords = (text) => {
    const words = text.trim().split(/\s+/);
    return words.length;
  };

  return (
    <>
    <div className="insert-data-popup" ref={insertRef}>
      <div className="popup-content data-box">
        <div className="insert-popup edit-pop">
          <div className="heading-content">
            <div className="heading">Edit Data</div>
            <div className="close-icon" onClick={handleEditClose}>
              <IoMdClose />
            </div>
          </div>
          <div style={{ width: "100%" }} className="insert-form">
            <form onSubmit={handleEditSubmit} className="submit">
              <div className="first-input-form-group">
                <EntryTypeFields
                  entryTypes={entryTypes}
                  selectedEntryType={selectedData.entry_type}
                  selectedLanguage={selectedLanguage}
                  value={selectedData}
                  errors={editValidationErrors}
                  translatedText={translatedText}
                  onEntryTypeChange={handleEntryTypeChange}
                  onFieldChange={handleEntryTypeFieldChange}
                  idPrefix={`report-edit-${selectedData.id || "case"}`}
                />
                <div className=" form-group">
                  <label htmlFor="dateOfSeizureInput">
                    {translatedText("date_of_seizure")}
                  </label>
                  <div className="date-picker-container">
                    <div className="input-group">
                      <DatePicker
                        selected={new Date(selectedData.date_of_seizure)}
                        className="form-control date-picker-input"
                        onChange={(date) =>
                          setSelectedData({
                            ...selectedData,
                            date_of_seizure: date.toISOString(),
                          })
                        }
                        dateFormat="dd/MM/yyyy" // Format as needed
                        id="dateOfSeizureInput"
                        showPopperArrow={false} // Optional: To hide the arrow on the date picker
                      />
                    </div>
                    <div className="input-group-appends">
                      <span
                        className="input-group-text"
                      // onClick={() => handleDateIconClick(index)}
                      >
                        <FcCalendar />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="exhibitnumber form-group">
                  <label htmlFor="exhibitNumberInput">
                    {" "}
                    {translatedText("exhibit_number")}
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      id="exhibitNumberInput"
                      className="form-control"
                      value={selectedData.exhibit_number}
                      onChange={(e) =>
                        setSelectedData({
                          ...selectedData,
                          exhibit_number: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="muddamaalTypeInput">
                    {translatedText("muddamaal_type")}
                  </label>
                  <div className="input-group">
                    <select
                      type="text"
                      id="muddamaalTypeInput"
                      className="form-control"
                      value={selectedData.muddamaal_type}
                      onChange={(e) =>
                        setSelectedData({
                          ...selectedData,
                          muddamaal_type: e.target.value,
                        })
                      }
                    >
                      {translations[
                        selectedLanguage
                      ].muddamaal_type_options.map(
                        (option, optionIndex) => (
                          <option key={optionIndex} value={option}>
                            {option}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
                {selectedData.muddamaal_type ===
                  translatedText("vehicle") && (
                    <div className="form-group">
                      <label htmlFor="vehicleReasonInput">
                        {translatedText("reason_for_impounding_the_vehicle")}
                      </label>
                      <div className="input-group">
                        <select
                          type="text"
                          id="vehicleReasonInput"
                          className="form-control"
                          value={selectedData.vehicle_reason}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              vehicle_reason: e.target.value,
                            })
                          }
                        >
                          {translations[
                            selectedLanguage
                          ].vehicle_reason_options.map(
                            (option, optionIndex) => (
                              <option key={optionIndex} value={option}>
                                {option}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>
                  )}
                <div className="quantity form-group">
                  <label htmlFor="quantityInput">
                    {translatedText("quantity")}
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      id="quantityInput"
                      className="form-control"
                      value={selectedData.quantity}
                      onChange={(e) =>
                        setSelectedData({
                          ...selectedData,
                          quantity: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="price form-group">
                  <label htmlFor="priceInput">
                    {translatedText("price")}
                  </label>
                  <div className="input-group">
                    <input
                      type="price"
                      id="priceInput"
                      className="form-control"
                      value={selectedData.price}
                      onChange={(e) =>
                        setSelectedData({
                          ...selectedData,
                          price: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="discription form-group">
                <label htmlFor="descriptionInput">
                  {translatedText("description")}
                </label>
                <div className="input-group">
                  <textarea
                    type="textarea"
                    id="descriptionInput"
                    className="form-control"
                    value={selectedData.description}
                    onChange={(e) =>
                      setSelectedData({
                        ...selectedData,
                        description: e.target.value,
                      })
                    }
                  />
                  <small className="word-count">
                    {countWords(selectedData.description)} words
                  </small>
                </div>
              </div>


              <div className="middle-input-form-group">
                <div className="acts-group">
                  <div className="form-group">
                    <label htmlFor="selectedOptions">Acts</label>
                    <Multiselect
                      options={options}
                      selectedValues={selectedOptions}
                      onSelect={handleSelect}
                      onRemove={handleRemove}
                      displayValue="name"
                      style={{
                        chips: {
                          background: "#007bff",
                          color: "#fff",
                          fontSize: "14px",
                        },
                        searchBox: { border: "1px solid #D9E1FF" },
                        optionContainer: {
                          border: "1px solid #007bff",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        },
                      }}
                      placeholder="Select options"
                      closeIcon="cancel"
                      avoidHighlightFirstOption={true}
                      showCheckbox={true}
                      hidePlaceholder={false}
                      closeOnSelect={false}
                    />
                  </div>
                </div>


                <div className="sub-middle-input-form-group">
                  {selectedOptions.map((option) => (
                    option.name !== 'Others Acts' && (
                      <div key={option.id} className="form-group">
                        <label htmlFor={option.name}>{option.name}</label>
                        <input
                          type="text"
                          name={option.name}
                          id={option.name}
                          className="form-control"
                          value={sectionOfLaws[option.name] || ""}
                          onChange={(e) =>
                            handleSectionOfLawChange(e, option.name)
                          }
                          placeholder={`Section of law for ${option.name}`}
                        />
                      </div>
                    )
                  ))}

                  {selectedOptions.some(
                    (option) => option.name === "Others Acts"
                  ) && (
                      <div className="other-acts-group">
                        <div className="form-group">
                          <label htmlFor="specifyAct">Specify Act</label>
                          <input
                            type="text"
                            name="specifyAct"
                            id="specifyAct"
                            className="form-control"
                            value={specifyAct}
                            onChange={(e) => setSpecifyAct(e.target.value)}
                            placeholder="Specify act"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="Others Acts">Others Acts</label>
                          <input
                            type="text"
                            name="Others Acts"
                            id="Others Acts"
                            className="form-control"
                            value={sectionOfLaws["Others Acts"] || ""}
                            onChange={(e) =>
                              handleSectionOfLawChange(e, "Others Acts")
                            }
                            placeholder="Section of law for Others Acts"
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>

              <button
                type="button"
                className="case-property-button"
                onClick={() => {
                  setShowCasePropertyPopup(true);
                  setShowEditForm(false);
                }}
              >
                Update Status of Case Property
              </button>
             



              <div className="last-group">
                <button
                  type="button"
                  className="btn close-button"
                  onClick={() => setShowEditForm(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  onSubmit={handleEditSubmit}
                  className="btn  save-button"
                >
                  Save
                </button>
              </div>
            </form>


          </div>
        </div>
      </div>
    </div>
    {showCasePropertyPopup && selectedData && (
        <div className="update-input-form-groups">
          <div className="update-input-group-contants">
            <div className="update-popup-heading">
              <div className="update-popup-heading-content">
                Update Case Property
              </div>
              <div
                className="update-popup-heading-content close-icons"
                onClick={closeUpdateButton}
              >
                <IoMdClose className="update-icon" />
              </div>
            </div>
            <div className="update-popup-header-separator"></div>
            <div className="update-popup-body">
              <form>
                <div className="form-group">
                  <label htmlFor="statusOfMuddamaalInput">
                    {translatedText("status_of_muddamaal")}
                  </label>
                  <div className="input-group">
                    <select
                      type="text"
                      id="statusOfMuddamaalInput"
                      className="form-control"
                      value={selectedData.status_of_muddamaal}
                      onChange={(e) =>
                        setSelectedData({
                          ...selectedData,
                          status_of_muddamaal: e.target.value,
                        })
                      }
                    >
                      {translations[
                        selectedLanguage
                      ].status_of_muddamaal_options.map(
                        (option, optionIndex) => (
                          <option key={optionIndex} value={option}>
                            {option}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>

                {translatedText("destroyed_disposed") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="disposalOnCourt">
                        {translatedText("disposal_on_court_order")}
                      </label>
                      <br />
                      <div className="input-group">
                        <select
                          id="disposalOnCourt"
                          value={selectedCourtOrderOption}
                          onChange={handleDropdownCourtOrderChange}
                          className="form-control"
                        >
                          <option value="Disposed">Disposed</option>
                          <option value="Auction">Auction</option>
                        </select>
                      </div>
                    </div>

                    {selectedCourtOrderOption === "Disposed" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="executiveOrder">
                            {translatedText("order_no_for_deputed")}
                          </label>

                          <input
                            type="number"
                            name="executiveOrder"
                            id="executiveOrder"
                            className="form-control"
                            value={sectionExecutiveOrderNo}
                            onChange={(e) =>
                              setSectionExecutiveOrderNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_order_no_deputed"
                            )}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="disposalDate">
                            {translatedText("date_of_disposal")}
                          </label>

                          <input
                            type="date"
                            name="disposalDate"
                            id="disposalDate"
                            className="form-control"
                            value={sectionDisposaldate}
                            onChange={(e) =>
                              setSectionsectionDisposaldate(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_handover_memo_no"
                            )}
                          />
                        </div>
                        <div className="form-group-attachment attach-new">
                          <label htmlFor="Attachment">
                            Attachment for disposal order
                          </label>
                          <div className="input-group-attachment">
                            <button
                              type="button"
                              className="challan-button"
                              onClick={handleUploadButtonClick}
                            >
                              <FiUpload /> Upload File
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleDisposalFileInputChange}

                            />
                            {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                              <span
                                className="inquiry-file-btn"
                                onClick={handleIconClick}
                              >
                                <MdAttachFile className="inquiry-file-icon" />{" "}
                                {`${selectedFiles.length}`}
                              </span>
                            )}
                            {isPopupOpens && (
                              <div className="attach-popups">
                                <div className="attach-popup-contant">
                                  <div className="attachment-header">
                                    <div className="attachment-header-content">
                                      Attachments
                                    </div>
                                    <button
                                      className="fiile-close-btn"
                                      onClick={handleCloseAttachment}
                                    >
                                      <IoCloseOutline className="file-close-icon" />
                                    </button>
                                  </div>
                                  {selectedFiles.length > 0 && (
                                    <div className="attach-scrroll-body">
                                      {selectedFiles.map((file, index) => (
                                        <div
                                          className="attach-popup-contant-body"
                                          key={index}
                                        >
                                          <div className="attach-file-container">
                                            <div className="attach-file-show">
                                              <div className="text-attachment">
                                                {file.name}
                                              </div>
                                              <div className="text-attachment-file">
                                                File Size:(
                                                {(file.size / 1024).toFixed(
                                                  2
                                                )}{" "}
                                                KB)
                                              </div>
                                            </div>
                                            <div
                                              className="file-delete-btn"
                                              onClick={() =>
                                                handleDeleteFile(index)
                                              }
                                            >
                                              <span>
                                                {" "}
                                                <MdDeleteOutline className="file-delete-icon" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {selectedCourtOrderOption === "Auction" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="auctionDate">
                            {translatedText("date_of_auction")}
                          </label>
                          <input
                            type="date"
                            name="auctionDate"
                            id="auctionDate"
                            className="form-control"
                            value={sectionAuctionDate}
                            onChange={(e) =>
                              setSectionAuctionDate(e.target.value)
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="auctionOrderNo">
                            {translatedText("auction_order_no")}
                          </label>
                          <input
                            type="number"
                            name="auctionOrderNo"
                            id="auctionOrderNo"
                            className="form-control"
                            value={sectionAuctionOrderNo}
                            onChange={(e) =>
                              setSectionAuctionOrderNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_auction_order_no"
                            )}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="awarded">
                            {translatedText("awarded_to_whom")}
                          </label>
                          <input
                            type="text"
                            name="awarded"
                            id="awarded"
                            className="form-control"
                            value={sectionAawarded}
                            onChange={(e) => setSectionAawarded(e.target.value)}
                            placeholder={translatedText(
                              "enter_awarded_recipient"
                            )}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="paymentMode">
                            {translatedText("payment_made_through")}
                          </label>
                          <div className="radio-input-option">
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="bankDeposit"
                                name="paymentMethod"
                                className="form-group-controls"
                                value="Bank Deposit"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="bankDeposit">
                                {translatedText("bank_deposit")}
                              </label>
                            </div>
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="cheque"
                                name="paymentMethod"
                                value="Cheque"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="cheque">
                                {translatedText("cheque")}
                              </label>
                            </div>
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="challan"
                                name="paymentMethod"
                                value="Challan"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="challan">
                                {translatedText("challan")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="auctionMemoNo">
                            {translatedText("handover_memo_no")}
                          </label>
                          <input
                            type="number"
                            name="auctionMemoNo"
                            id="auctionMemoNo"
                            className="form-control"
                            value={sectionAuctionMemoNo}
                            onChange={(e) =>
                              setSectionAuctionMemoNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_handover_memo_no"
                            )}
                          />
                        </div>
                        <div className="form-group-attachment attach-new">
                          <label htmlFor="Attachment">
                            Attachment for auction order
                          </label>
                          <div className="input-group-attachment">
                            <button
                              type="button"
                              className="challan-button"
                              onClick={handleUploadButtonClick}
                            >
                              <FiUpload /> Upload File
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleAuctionFileInputChange}

                            />
                            {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                              <span
                                className="inquiry-file-btn"
                                onClick={handleIconClick}
                              >
                                <MdAttachFile className="inquiry-file-icon" />{" "}
                                {`${selectedFiles.length}`}
                              </span>
                            )}
                            {isPopupOpens && (
                              <div className="attach-popups">
                                <div className="attach-popup-contant">
                                  <div className="attachment-header">
                                    <div className="attachment-header-content">
                                      Attachments
                                    </div>
                                    <button
                                      className="fiile-close-btn"
                                      onClick={handleCloseAttachment}
                                    >
                                      <IoCloseOutline className="file-close-icon" />
                                    </button>
                                  </div>
                                  {selectedFiles.length > 0 && (
                                    <div className="attach-scrroll-body">
                                      {selectedFiles.map((file, index) => (
                                        <div
                                          className="attach-popup-contant-body"
                                          key={index}
                                        >
                                          <div className="attach-file-container">
                                            <div className="attach-file-show">
                                              <div className="text-attachment">
                                                {file.name}
                                              </div>
                                              <div className="text-attachment-file">
                                                File Size:(
                                                {(file.size / 1024).toFixed(
                                                  2
                                                )}{" "}
                                                KB)
                                              </div>
                                            </div>
                                            <div
                                              className="file-delete-btn"
                                              onClick={() =>
                                                handleDeleteFile(index)
                                              }
                                            >
                                              <span>
                                                {" "}
                                                <MdDeleteOutline className="file-delete-icon" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : null}

                {translatedText("release_on_court_order") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="courtOrderNo">
                        {translatedText("court_order_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="CourtOrderNo"
                          id="CourtOrderNo"
                          className="form-control"
                          value={sectionCourtOrderNo}
                          onChange={(e) =>
                            setSectionCourtOrderNo(e.target.value)
                          }
                          placeholder={translatedText("enter_court_order_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="releasedToWhom">
                        {translatedText("released_to_whom")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="ReleasedToWhom"
                          id="ReleasedToWhom"
                          className="form-control"
                          value={sectionReleased}
                          onChange={(e) => setSectionReleased(e.target.value)}
                          placeholder={translatedText("enter_releaser_name")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="releseddate">
                        {translatedText("date_of_release")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          name="Releseddate"
                          id="Releseddate"
                          className="form-control"
                          value={sectionRelesedDate}
                          onChange={(e) =>
                            setSectionRelesedDate(e.target.value)
                          }
                          placeholder={translatedText("enter_date_of_release")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="gdNo">
                        {translatedText("gd_entry_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="GdNo"
                          id="GdNo"
                          className="form-control"
                          value={sectionGdNo}
                          onChange={(e) => setSectionGdNo(e.target.value)}
                          placeholder={translatedText("enter_gd_entry_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group-attachment attach-new">
                      <label htmlFor="Attachment">
                        Attachment for release on court order
                      </label>
                      <div className="input-group-attachment">
                        <button
                          type="button"
                          className="challan-button"
                          onClick={handleUploadButtonClick}
                        >
                          <FiUpload /> Upload File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleCourtOrderFileInputChange}

                        />
                        {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                          <span
                            className="inquiry-file-btn"
                            onClick={handleIconClick}
                          >
                            <MdAttachFile className="inquiry-file-icon" />{" "}
                            {`${selectedFiles.length}`}
                          </span>
                        )}
                        {isPopupOpens && (
                          <div className="attach-popups">
                            <div className="attach-popup-contant">
                              <div className="attachment-header">
                                <div className="attachment-header-content">
                                  Attachments
                                </div>
                                <button
                                  className="fiile-close-btn"
                                  onClick={handleCloseAttachment}
                                >
                                  <IoCloseOutline className="file-close-icon" />
                                </button>
                              </div>
                              {selectedFiles.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {selectedFiles.map((file, index) => (
                                    <div
                                      className="attach-popup-contant-body"
                                      key={index}
                                    >
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {file.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size:(
                                            {(file.size / 1024).toFixed(2)} KB)
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteFile(index)
                                          }
                                        >
                                          <span>
                                            {" "}
                                            <MdDeleteOutline className="file-delete-icon" />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("comes_from_fsl") === selectedData.status_of_muddamaal ||
                  translatedText("released_in_fsl") === selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="fslList">FSL List</label>
                      <br />
                      <div className="input-group">
                        <select
                          id="fslList"
                          value={selectedData.fslList}
                          className="form-control"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              fslList: e.target.value,
                            })
                          }
                        >
                          <option value="FSL Port Blair">FSL Port Blair</option>
                          <option value="All CFSL">All CFSL</option>
                        </select>
                      </div>
                    </div>

                    {selectedData.fslList === 'All CFSL' && (
                      <div className="form-group">
                        <label htmlFor="cfslName">{translatedText("name_of_cfsl")}</label>
                        <br />
                        <input
                          type="text"
                          id="cfslName"
                          className="form-control"
                          value={sectionCfslName}
                          onChange={(e) => setSectionCfslName(e.target.value)}
                          placeholder={translatedText("enter_name_of_cfsl")}
                        />
                      </div>
                    )}
                  </>
                ) : null}


                {translatedText("handed_over_to_other_department") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="MemoNo">
                        {translatedText("handover_memo_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="MemoNo"
                          id="MemoNo"
                          className="form-control"
                          value={sectionMemoNo}
                          onChange={(e) => setSectionMemoNo(e.target.value)}
                          placeholder={translatedText("enter_handover_memo_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="DateOfHandingOver">
                        {translatedText("date_of_handing_over")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          name="DateOfHandingOver"
                          id="DateOfHandingOver"
                          className="form-control"
                          value={selectedDateOfHandingOver}
                          onChange={(e) =>
                            setSelectedDateOfHandingOver(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group-attachment attach-new">
                      <label htmlFor="Attachment">
                        Attachment for Handover memo
                      </label>
                      <div className="input-group-attachment">
                        <button
                          type="button"
                          className="challan-button"
                          onClick={handleUploadButtonClick}
                        >
                          <FiUpload /> Upload File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleHandedOverFileInputChange}

                        />
                        {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                          <span
                            className="inquiry-file-btn"
                            onClick={handleIconClick}
                          >
                            <MdAttachFile className="inquiry-file-icon" />{" "}
                            {`${selectedFiles.length}`}
                          </span>
                        )}
                        {isPopupOpens && (
                          <div className="attach-popups">
                            <div className="attach-popup-contant">
                              <div className="attachment-header">
                                <div className="attachment-header-content">
                                  Attachments
                                </div>
                                <button
                                  className="fiile-close-btn"
                                  onClick={handleCloseAttachment}
                                >
                                  <IoCloseOutline className="file-close-icon" />
                                </button>
                              </div>
                              {selectedFiles.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {selectedFiles.map((file, index) => (
                                    <div
                                      className="attach-popup-contant-body"
                                      key={index}
                                    >
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {file.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size:(
                                            {(file.size / 1024).toFixed(2)} KB)
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteFile(index)
                                          }
                                        >
                                          <span>
                                            {" "}
                                            <MdDeleteOutline className="file-delete-icon" />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("police_station_account") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("name_of_the_account_holder")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={translatedText("enter_the_name_of_the_borrower_form_the_p_O_station")}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("date_received_from_the_p_o_station")}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          className="form-control"
                          name="bankTrans"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>
                    {userState === "Gujarat" && (
                      <div className="order-status form-group">
                        <label htmlFor="Order_Status">
                          {translatedText("malkhana_register_no")}
                        </label>
                        <div className="input-group">
                          <input
                            type="number"
                            id="Order_Status"
                            className="form-control"
                            name="Order_Status"
                            placeholder={translatedText("enter_malkhana_nos")}
                            value={selectedData.order_no}
                            onChange={(e) =>
                              setSelectedData({
                                ...selectedData,
                                order_status: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                  </>
                ) : null}

                {translatedText("comes_from_fsl") ===
                  selectedData.status_of_muddamaal ||
                  translatedText("comes_from_court") ===
                  selectedData.status_of_muddamaal ||
                  translatedText("comes_from_bank") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("police_station_account") ===
                          selectedData.status_of_muddamaal
                          ? translatedText("name_of_the_account_holder")
                          : translatedText("comes_from_fsl") ===
                            selectedData.status_of_muddamaal
                            ? translatedText(
                              "name_of_the_one_to_be_taken_from_FSL"
                            )
                            : translatedText("comes_from_court") ===
                              selectedData.status_of_muddamaal
                              ? translatedText(
                                "name_of_the_person_be_summoned_from_the_court"
                              )
                              : translatedText("comes_from_bank") ===
                                selectedData.status_of_muddamaal
                                ? translatedText("name_of_the_borrower_from_the_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={
                            translatedText("police_station_account") ===
                              selectedData.status_of_muddamaal
                              ? translatedText(
                                "enter_the_name_of_the_borrower_form_the_p_O_station"
                              )
                              : translatedText("comes_from_fsl") ===
                                selectedData.status_of_muddamaal
                                ? translatedText(
                                  "enter_the_name_of_the_borrower_form_the_fsl"
                                )
                                : translatedText("comes_from_court") ===
                                  selectedData.status_of_muddamaal
                                  ? translatedText(
                                    "enter_the_name_of_the_borrower_form_the_court"
                                  )
                                  : translatedText("comes_from_bank") ===
                                    selectedData.status_of_muddamaal
                                    ? translatedText(
                                      "enter_the_name_of_the_borrower_form_the_bank"
                                    )
                                    : "Name"
                          }
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("police_station_account") ===
                          selectedData.status_of_muddamaal
                          ? translatedText("date_received_from_the_p_o_station")
                          : translatedText("comes_from_fsl") ===
                            selectedData.status_of_muddamaal
                            ? translatedText("date_received_from_the_fsl")
                            : translatedText("comes_from_court") ===
                              selectedData.status_of_muddamaal
                              ? translatedText("date_received_from_the_court")
                              : translatedText("comes_from_bank") ===
                                selectedData.status_of_muddamaal
                                ? translatedText("date_received_from_the_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          className="form-control"
                          name="bankTrans"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>

                    <div className="order-status form-group">
                      <label htmlFor="Order_Status">
                        {translatedText("order_no")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Order_Status"
                          className="form-control"
                          name="Order_Status"
                          value={selectedData.order_no}
                          placeholder={translatedText("enter_order_no")}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              order_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("returned") ===
                  selectedData.status_of_muddamaal ||
                  translatedText("released_in_fsl") ===
                  selectedData.status_of_muddamaal ||
                  translatedText("pending_in_court") ===
                  selectedData.status_of_muddamaal ||
                  translatedText("deposited_in_bank") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("returned") ===
                          selectedData.status_of_muddamaal
                          ? translatedText("name_of_the_returen")
                          : translatedText("released_in_fsl") ===
                            selectedData.status_of_muddamaal
                            ? translatedText("name_of_the_sender_in_fsl")
                            : translatedText("pending_in_court") ===
                              selectedData.status_of_muddamaal
                              ? translatedText("name_of_the_depositing_in_court")
                              : translatedText("deposited_in_bank") ===
                                selectedData.status_of_muddamaal
                                ? translatedText("name_of_the_depositing_in_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={
                            translatedText("returned") ===
                              selectedData.status_of_muddamaal
                              ? translatedText(
                                "enter_the_name_of_the_returnee"
                              )
                              : translatedText("released_in_fsl") ===
                                selectedData.status_of_muddamaal
                                ? translatedText(
                                  "enter_the_name_of_the_sender"
                                )
                                : translatedText("pending_in_court") ===
                                  selectedData.status_of_muddamaal
                                  ? translatedText(
                                    "enter_the_name_of_the_submiter_person_court"
                                  )
                                  : translatedText("deposited_in_bank") ===
                                    selectedData.status_of_muddamaal
                                    ? translatedText(
                                      "enter_the_name_of_the_submiter_person_bank"
                                    )
                                    : "Name"
                          }
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("returned") ===
                          selectedData.status_of_muddamaal
                          ? translatedText("return_date")
                          : translatedText("released_in_fsl") ===
                            selectedData.status_of_muddamaal
                            ? translatedText("date_deposite_in_the_fsl")
                            : translatedText("pending_in_court") ===
                              selectedData.status_of_muddamaal
                              ? translatedText("date_deposite_in_the_court")
                              : translatedText("deposited_in_bank") ===
                                selectedData.status_of_muddamaal
                                ? translatedText("date_deposite_in_the_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          name="bankTrans"
                          className="form-control"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>

                    <div className="send-status form-group">
                      <label htmlFor="Send_Status">
                        {translatedText("order_no")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Send_Status"
                          name="Send_Status"
                          className="form-control"
                          value={selectedData.javak_no}
                          placeholder={translatedText("enter_order_no")}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              send_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </form>
              <div className="last-edit-buttons">
                <button
                  type="button"
                  className="btn close-button buttons"
                  onClick={() => setShowCasePropertyPopup(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  onClick={updateStatusDetails}
                  className="btn  save-button buttons"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      </>
  );
}

export default EditPopup;
